<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="!loading">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <p>Заявка: <strong>{{ order.id }}</strong></p>
              <p>Клиент: <strong>{{ order.client_name }}</strong></p>
              <p>Телефоны:</p>
              <p v-for="p in order.order_phones">
                <a :href="`tel:+${p.phone.phone}`">{{ p.phone.phone }}</a>
              </p>
              <p>Дата доставки: <strong>{{ printDate(order.delivery_date, 'DD.MM.YYYY') }}</strong></p>
              <p>Адрес: {{ order.address }}</p>
              <RunnerSalaryRate :rate="order?.extra_options?.salary_rate ?? 0"/>
            </div>
            <div class="col-md-6">
              <table class="table table-sm mt-0 table-style-1">
                <thead>
                <tr>
                  <th>Препарат</th>
                  <th>кол</th>
                  <!--                <th>стоимость</th>-->
                  <!--                <th>сумма</th>-->
                </tr>
                </thead>
                <tbody>
                <tr v-for="d in order.details">
                  <td>{{ d.drug.title }}</td>
                  <td>{{ d.qty }}</td>
                  <!--                <td>{{ d.price }}</td>-->
                  <!--                <td>{{ d.qty * d.price }}</td>-->
                </tr>
                <tr>
                  <td>доставка:</td>
                  <td>{{ order.delivery_price ?? 0 }}</td>
                </tr>
                <tr>
                  <td>итого:</td>
                  <td><strong>{{ order.price ?? 0 }}</strong></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h6>История</h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <template v-if="(phoneCalls ?? []).length">
                <p>Всего звонков: <strong>{{ phoneCalls.length }}</strong></p>
                <button @click="showPhoneCalls = !showPhoneCalls" v-if="!showPhoneCalls"
                        class="btn btn-xs btn-outline-info">Показать звонки
                </button>
                <div v-if="showPhoneCalls" class="mb-1">
                  <div v-for="call in phoneCalls">
                    <p class="fs-12">{{ printDate(call.created_at, 'DD.MM.YYYY HH:mm') }}</p>
                    <audio controls v-if="call.file_link">
                      <source
                        :src="`/api/noa/mangoRecord/${call.id}`"
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio tag.
                    </audio>
                  </div>
                </div>
              </template>
              <template v-else>
                <p>Нет звонков в системе по этому номеру</p>
              </template>
            </div>
            <div class="col-md-8">
              <template v-if="(historyOrders ?? []).length">
                <table class="table table-style-1 mt-0">
                  <tbody>
                  <tr v-for="o in historyOrders">
                    <td>
                      <p v-for="d in o.details">{{ d.drug.title }}</p>
                    </td>
                    <td>
                      <OrderStatus :status="o.status"/>
                      <p class="fs-12 text-muted" v-if="o.reject_comment">{{ o.reject_comment }}</p>
                    </td>
                    <td>
                      <span class="fs-12">{{ printDate(o.created_at, 'DD.MM.YYYY') }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </template>
              <template v-else>
                Заявок по этому номеру телефона не найдены
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import RunnerSalaryRate from "@/views/orders/RunnerSalaryRate.vue";
import OrderStatus from "@/components/orders/ordersData/OrderStatus.vue";

export default {
  components: {OrderStatus, RunnerSalaryRate},
  props: ['orderId'],
  data() {
    return {
      loading: true,
      showPhoneCalls: false,
      phoneCalls: [],
      historyOrders: [],
      order: null,
    }
  },
  mounted() {
    this.getOrder();
  },
  methods: {
    async getOrder() {
      this.loading = true;
      const {data} = await api.index('/new/orders/details/' + this.orderId);
      if (data.success) {
        this.historyOrders = data.history_orders;
        this.phoneCalls = data.phoneCalls;
        this.order = data.order;
      } else {
        toastr['warning'](data.message || 'ошибка сервера')
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
audio {
  width: 100%;
}
</style>
